import React, {useEffect} from 'react';
import "../style/Filter.scss"

// icon
import leftRightIcon from "../assets/icon/icons8-sorting-arrows-horizontal-32.png";


const Filter = ({filters, setFilters, refHook, Image}) => {

    const {leftRight} = filters;

    useEffect(() => {
        if(Image) conditionalStylesLeftRight();
    }, [leftRight])

    const conditionalStylesLeftRight = () => {
        let refStyle = refHook.current.style;
        if(leftRight === true){
            refStyle.transform = "rotateY(180deg)"
        } else if(leftRight === false){
            refStyle.transform = "rotateY(0deg)"
        }
    }

    return (
        <div className='range'>
            <div>
                <label>blur</label>
                <input type="range" min={0} max={5} defaultValue={0} onChange={(e) =>setFilters({...filters, blur: filters.blur = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>brightness</label>
                <input type="range" min={0} max={100} defaultValue={100} onChange={(e) => setFilters({...filters, brightness: filters.brightness = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>contrast</label>
                <input type="range" min={0} max={100} defaultValue={100} onChange={(e) => setFilters({...filters, contrast: filters.contrast = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>grayscale</label>
                <input type="range" min={0} max={100} defaultValue={0} onChange={(e) => setFilters({...filters, grayscale: filters.grayscale = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>hue-rotate</label>
                <input type="range" min={0} max={360} defaultValue={0} onChange={(e) => setFilters({...filters, hueRotate: filters.hueRotate = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>invert</label>
                <input type="range" min={0} max={100} defaultValue={0} onChange={(e) => setFilters({...filters, invert: filters.invert = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>opacity</label>
                <input type="range" min={0} max={100} defaultValue={100} onChange={(e) => setFilters({...filters, opacity: filters.opacity = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>seturate</label>
                <input type="range" min={0} max={100} defaultValue={100} onChange={(e) => setFilters({...filters, seturate: filters.seturate = e.target.valueAsNumber})}/>
            </div>
            <div>
                <label>sepia</label>
                <input type="range" min={0} max={100} defaultValue={0} onChange={(e) => setFilters({...filters, sepia: filters.sepia = e.target.valueAsNumber})}/>
            </div>
            <button style={{background: leftRight && "#409DFF"}} onClick={() => {
                setFilters({...filters, leftRight: filters.leftRight = !filters.leftRight});
                conditionalStylesLeftRight()
            }}>
                <img src={leftRightIcon} alt='translate'/>
            </button>
        </div>                                
    );
};

export default Filter;